export const shareCardHandler = async function (name?: string) {
  fetch(`${process.env.REACT_APP_NODE_PATH}/img/card/${name}-share.png`)
    .then(function (response) {
      return response.blob();
    })
    .then(function (blob) {
      var file = new File([blob], "banimagic.png", { type: "image/png" });
      var filesArray = [file];
      if (navigator.canShare && navigator.canShare({ files: filesArray })) {
        navigator.share({
          // text: "some_text",
          files: filesArray,
          // title: "some_title",
          // url: `assets/img/card/${name}.png`,
        });
      } else {
        console.log("error");
      }
    });
};

export function vibratePhone(deg: number) {
  try {
    window.navigator.vibrate(deg);
  } catch (err) {
    console.error(err);
  }
}
